<template>
    <div>
        <div class=" welcome font-poppins text-white pb-10 pt-40 md:hidden">
            <div class=" w-1/2 m-auto">
                <div>
                    <p class=" text-5xl font-bold">Welcome!</p>
                    <p class=" mt-10 w-1/2 lg:w-full">Enter the tracking number generated on the app or received by SMS to see the progress of the order.</p>
                </div>
                
                <div class=" flex mt-6">
                    <img src="../Images/Pagination01.png" alt="pagination">
                    <img class=" ml-2" src="../Images/Pagination02.png" alt="pagination">
                    <img class="ml-2" src="../Images/Pagination01.png" alt="pagination">
                </div>

                <div class=" mt-20">
                    <p class=" text-green-600 font-bold">GET IN TOUCH</p>
                    <p class=" w-full text-sm mt-6">Feel free to get in touch with us via email.</p>
                </div>

                <div class=" mt-6 text-xl font-semibold md:mt-1">
                    <p>info@carrygo.me</p>
                </div>

                <div class=" flex mt-4">
                    <a href="https://twitter.com/_CarryGoNg?t=hr9WEcQiMa56dd8G6ilY-g&s=09" target="_blank"><img src="../Images/twitter-icon.png" alt="twitter"></a>
                    <a href="https://www.facebook.com/CarryGo-Logistech-100760155865136/" target="_blank"> <img class="ml-3" src="../Images/facebook-icon.png" alt="facebook"></a>
                    <a href="https://instagram.com/carrygo_ng?utm_medium=copy_link" target="_blank"><img class="ml-3" src="../Images/instagram-icon.png" alt="instagram"></a>
                </div>
            </div>    
        </div>
    </div>
</template>


<style scoped>
    .welcome {
        background-image: linear-gradient(rgba(0,0,0,.7),rgba(0, 0, 0, 0.9)), url('../Images/track-bg.png');
        background-repeat: no-repeat;
        background-size: cover;
        height: 100vh;
        /* mix-blend-mode: multiply; */
    }
</style>